import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לילד",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה לתקן.",
      "אני רק שם/ה לב לילד הפנימי.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה לתקן.",
      "אני רק שם/ה לב לילד הפנימי.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הילד הזה מתעורר בי?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ],
      [
      "מתי הילד הזה מתעורר בי?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב הוא כבר חיבוק קטן."
    ],
      [
      "לשים לב הוא כבר חיבוק קטן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה הוא בוחר",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שהילד בוחר/ת.",
      "בלי הבטחות.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב למה שהילד בוחר/ת.",
      "בלי הבטחות.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה היה חסר לו אז?",
      "מה הוא מבקש ממני היום?",
      "מה קשה לי לתת לו?"
    ],
      [
      "מה היה חסר לו אז?",
      "מה הוא מבקש ממני היום?",
      "מה קשה לי לתת לו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לראות את הצורך מרכך משהו בי."
    ],
      [
      "לראות את הצורך מרכך משהו בי."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על הצורך.",
      "לכתוב מילה אחת על הצורך."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "המסר שנשאר",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למסרים שהילד ספג.",
      "בלי שיפוט.",
      "רק אמת."
    ],
      [
      "היום אני שם/ה לב למסרים שהילד ספג.",
      "בלי שיפוט.",
      "רק אמת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה מסר נשאר בי מאז?",
      "איך המסר הזה משפיע עליי היום?",
      "מה הייתי רוצה להחליף בו?"
    ],
      [
      "איזה מסר נשאר בי מאז?",
      "איך המסר הזה משפיע עליי היום?",
      "מה הייתי רוצה להחליף בו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מסר ישן מבקש תיקון עדין."
    ],
      [
      "מסר ישן מבקש תיקון עדין."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת עדינה במקום המסר.",
      "לכתוב מילה אחת עדינה במקום המסר."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "להיות איתו",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להיות עם הילד לרגע.",
      "בלי לתקן.",
      "רק להיות."
    ],
      [
      "היום אני מתרגל/ת להיות עם הילד לרגע.",
      "בלי לתקן.",
      "רק להיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הוא יושב בי?",
      "מה הוא בוחר/ת ממני עכשיו?",
      "איך זה מרגיש להיות איתו רגע?"
    ],
      [
      "איפה הוא יושב בי?",
      "מה הוא בוחר/ת ממני עכשיו?",
      "איך זה מרגיש להיות איתו רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להיות איתו לרגע הוא כבר שינוי קטן."
    ],
      [
      "להיות איתו לרגע הוא כבר שינוי קטן."
    ]
    ),
    action: localizedGenderNode(
      "לשים יד על הלב ולנשום.",
      "לשים יד על הלב ולנשום."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הפחד שלא אהיה רצוי/ה",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לפחד שלא אהיה רצוי/ה.",
      "לא להילחם.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב לפחד שלא אהיה רצוי/ה.",
      "לא להילחם.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הפחד הזה מתעורר?",
      "מה הוא אומר לי?",
      "איך הוא מנסה לשמור עליי?"
    ],
      [
      "מתי הפחד הזה מתעורר?",
      "מה הוא אומר לי?",
      "איך הוא מנסה לשמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הפחד מבקש שמירה."
    ],
      [
      "הפחד מבקש שמירה."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני רואה אותך\".",
      "לומר לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "בקשה קטנה לחום",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה קטנה לחום.",
      "לא גדולה.",
      "קטנה."
    ],
      [
      "היום אני מנסח/ת בקשה קטנה לחום.",
      "לא גדולה.",
      "קטנה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה חום חסר לי?",
      "איך אפשר לבקש אותו בעדינות?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "איזה חום חסר לי?",
      "איך אפשר לבקש אותו בעדינות?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לרכך."
    ],
      [
      "בקשה אחת יכולה לרכך."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "fear",
    title: "רגע קטן של חיבוק",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת רגע קטן של נחמה.",
      "לא הרבה.",
      "רק מעט."
    ],
      [
      "היום אני מחפש/ת רגע קטן של נחמה.",
      "לא הרבה.",
      "רק מעט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הרגשתי נחמה לאחרונה?",
      "מה אפשר לה לקרות?",
      "מה יכול להזמין עוד רגע כזה?"
    ],
      [
      "מתי הרגשתי נחמה לאחרונה?",
      "מה אפשר לה לקרות?",
      "מה יכול להזמין עוד רגע כזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע קטן משנה כיוון."
    ],
      [
      "רגע קטן משנה כיוון."
    ]
    ),
    action: localizedGenderNode(
      "לזכור רגע כזה.",
      "לזכור רגע כזה."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "need",
    title: "גבול שמגן עליי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת גבול קטן שמגן עליי.",
      "לא כדי להתרחק.",
      "רק לשמור."
    ],
      [
      "היום אני בודק/ת גבול קטן שמגן עליי.",
      "לא כדי להתרחק.",
      "רק לשמור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני נותן/ת יותר מדי?",
      "איזה גבול קטן יקל עליי?",
      "איך אני יכול/ה לומר אותו לעצמי?"
    ],
      [
      "איפה אני נותן/ת יותר מדי?",
      "איזה גבול קטן יקל עליי?",
      "איך אני יכול/ה לומר אותו לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול קטן שומר על הלב."
    ],
      [
      "גבול קטן שומר על הלב."
    ]
    ),
    action: localizedGenderNode(
      "משפט גבול אחד לעצמי.",
      "משפט גבול אחד לעצמי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "need",
    title: "להישאר עם עצמי",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר עם עצמי כשעולה הכאב הישן.",
      "לא לברוח.",
      "רק להיות."
    ],
      [
      "היום אני מתרגל/ת להישאר עם עצמי כשעולה הכאב הישן.",
      "לא לברוח.",
      "רק להיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה עוזר לי להישאר איתי?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ],
      [
      "מה עוזר לי להישאר איתי?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להישאר איתי הוא עוגן קטן."
    ],
      [
      "להישאר איתי הוא עוגן קטן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת בכל פעם שעולה התחושה.",
      "נשימה אחת בכל פעם שעולה התחושה."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה אחת ברורה",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה אחת ברורה לעצמי.",
      "לא גדולה.",
      "ברורה."
    ],
      [
      "היום אני מנסח/ת בקשה אחת ברורה לעצמי.",
      "לא גדולה.",
      "ברורה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה עכשיו כדי להרגיש רצוי/ה?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "מה אני בוחר/ת/ה עכשיו כדי להרגיש רצוי/ה?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת ברורה יכולה להרגיע."
    ],
      [
      "בקשה אחת ברורה יכולה להרגיע."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "perspective",
    title: "ערך אחד שמחזיק אותי",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת ערך אחד שמחזיק אותי.",
      "קטן.",
      "אבל אמיתי."
    ],
      [
      "היום אני מחפש/ת ערך אחד שמחזיק אותי.",
      "קטן.",
      "אבל אמיתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך חשוב לי באמת?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ],
      [
      "איזה ערך חשוב לי באמת?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך אחד יכול להיות עוגן."
    ],
      [
      "ערך אחד יכול להיות עוגן."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שמבטאת את הערך.",
      "מילה אחת שמבטאת את הערך."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "strength",
    title: "להקשיב לי",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להקשיב לי מול הילד.",
      "לא לדחות.",
      "רק לשמוע."
    ],
      [
      "היום אני מתרגל/ת להקשיב לי מול הילד.",
      "לא לדחות.",
      "רק לשמוע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה לשמוע מעצמי היום?",
      "מה אני נותן/ת לאחרים שאני לא נותן/ת לי?",
      "איך אפשר לתת את זה לעצמי?"
    ],
      [
      "מה אני בוחר/ת/ה לשמוע מעצמי היום?",
      "מה אני נותן/ת לאחרים שאני לא נותן/ת לי?",
      "איך אפשר לתת את זה לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להקשיב לי הוא תיקון קטן."
    ],
      [
      "להקשיב לי הוא תיקון קטן."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד עדין לעצמי.",
      "משפט אחד עדין לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "strength",
    title: "צעד קטן של קבלה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן של קבלה.",
      "בלי דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן של קבלה.",
      "בלי דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן מספיק כדי לזוז."
    ],
      [
      "צעד קטן מספיק כדי לזוז."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לאהבה פנימית.",
      "כשאני נרעד/ת.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי לאהבה פנימית.",
      "כשאני נרעד/ת.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הילד הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על הילד הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה לפגוש אותו ולהישאר עם עצמי."
    ],
      [
      "אני יכול/ה לפגוש אותו ולהישאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const anInnerChildWhoDidnTFeelWantedLovedBlueprintHe = buildNormalizedPilotBlueprint({
  id: "an_inner_child_who_didn_t_feel_wanted_loved_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "an_inner_child_who_didn_t_feel_wanted_loved",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "ילד פנימי שלא הרגיש רצוי / אהוב",
    en: "An inner child who did not feel wanted / loved",
    es: "Un niño interior que no se sintió querido / amado",
  },
  days,
});

export default anInnerChildWhoDidnTFeelWantedLovedBlueprintHe;
